import { useState, useEffect, useCallback } from 'react';
import { useDispatch, connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { IReportItem } from 'APIPackage/MainModule/interfaces/IReportItem';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { catalogGet } from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';
import { dictionariesKnoOrganizationsItemGet } from 'CorePackage/DictionariesModule/actions/dictionariesActions';

import { ReportTable } from './ReportTable';
import { ReportSettings } from './ReportSettings';
import styles from './Reports.module.scss';
import { reportItems } from '../constants/reportItems';
import { erknmReportItems } from '../constants/erknmReportItems';

interface IReportsProps {
  isErknm: boolean;
}

export const ReportsWithoutStore = ({ isErknm }: IReportsProps) => {
  const [tableItems, setTableItems] = useState<IReportItem[]>(
    reportItems.map(item => ({ type: item, name: UploadFileTypesEnum[item], isActive: false })),
  );

  useEffect(() => {
    if (isErknm) {
      setTableItems(erknmReportItems.map(item => ({ ...item, name: UploadFileTypesEnum[item.type], isActive: false })));
    } else {
      setTableItems(reportItems.map(item => ({ type: item, name: UploadFileTypesEnum[item], isActive: false })));
    }
  }, [isErknm]);

  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffect(() => {
    if (isErknm) {
      dispatch(catalogGet(CommonCatalogsNamesEnum.FEDERAL_LAWS_248));
      dispatch(dictionariesKnoOrganizationsItemGet());
    } else {
      dispatch(catalogGet(CommonCatalogsNamesEnum.FEDERAL_LAWS_294));
      dispatch(dictionariesKnoOrganizationsItemGet());
    }
  }, [dispatch, isErknm]);

  const handleTableItemClick = useCallback(
    (type: IReportItem['type']) => {
      setTableItems(
        tableItems.map(item => ({
          ...item,
          isActive: item.type === type ? !item.isActive : false,
        })),
      );
    },
    [tableItems],
  );

  const activeItem = tableItems.find(tableItem => tableItem.isActive);

  return (
    <div className={styles.Container}>
      <div className={styles.ReportsPanel}>
        <ReportTable items={tableItems} onItemClick={handleTableItemClick} />
        <ReportSettings activeItem={activeItem} />
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  isErknm: getLawInterface(state) === LawInterfacesEnum.FZ_248,
});

export const Reports = connect(mapStateToProps)(ReportsWithoutStore);
